import { flow } from 'fp-ts/function';
import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

import { DEPRECATED_DOMAIN_ERROR_KEY } from '../../constants';
import { parentSelector } from '../../selectors/parentSelector';

const getError = createSelector(parentSelector, get('error'));

export const getErrorMessage = flow(getError, get('message'));

export const getErrorKey = flow(getError, get('key'));

export const isDeprecatedDomainError = flow(getErrorKey, (errorKey) => errorKey === DEPRECATED_DOMAIN_ERROR_KEY);
